import React from 'react';
import styled from 'styled-components';
import { PropertySpecFragment } from '../../../gatsby-graphql';
import { CheckIcon } from '../../icons';

interface IPropertySelector {
  propertySpecs: PropertySpecFragment[];
  handlePropertySpecChange(checked: boolean, name: string): void;
}

const PropertySpecSelector: React.FC<IPropertySelector> = ({
  propertySpecs,
  handlePropertySpecChange,
}) => (
  <Container>
    {propertySpecs.map((propertySpec) => (
      <Option key={propertySpec.name}>
        <input
          type="checkbox"
          id={propertySpec.name as string}
          name={propertySpec.name as string}
          value={propertySpec.name as string}
          onChange={(e) =>
            handlePropertySpecChange(
              e.target.checked,
              propertySpec.name as string
            )
          }
        />
        <label htmlFor={propertySpec.name as string}>{propertySpec.name}</label>
        <span>
          <CheckIcon />
        </span>
      </Option>
    ))}
  </Container>
);

const Container = styled.div`
  display: flex;
  flex-direction: column;
`;

const Option = styled.div`
  cursor: pointer;
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  &:not(:last-of-type) {
    margin-bottom: 10px;
  }
  label {
    flex: 1;
    padding-right: 18px;
    cursor: pointer;
    font-size: 14px;
    line-height: 16px;
    font-weight: 500;
    color: #8b8c8f;
  }
  input {
    position: absolute;
    opacity: 0;
    cursor: pointer;
    height: 0;
    width: 0;
    &:checked {
      ~ span {
        background-color: ${(props) => props.theme.colors.primary};
        border: ${(props) => `1px solid ${props.theme.colors.primary}`};
      }
    }
  }
  span {
    pointer-events: none;
    position: absolute;
    top: 0;
    right: 0;
    height: 18px;
    width: 18px;
    border-radius: 2px;
    background-color: transparent;
    border: 1px solid #8b8c8f;
    display: flex;
    align-items: center;
    justify-content: center;
    svg {
      height: 14px;
      width: 14px;
    }
  }
`;

export default React.memo(PropertySpecSelector);
